const integerValue = value => value && value.replace(/\D/g, '');

export default integerValue;
